import axios from 'axios';

export function postData(data) {
  return axios({
    method: 'post',
    url: `https://workshop-pro.staging.brew-systems.co.uk/wp-json/force24/v1/register`,
    data
  })
}
